/* Adds a condensed state to the floating nav once the page scrolls. */
(() => {
  const group = document.getElementById('header-group');
  if (!group) return;

  const THRESHOLD = 24;
  let ticking = false;

  /* Content clearance is derived from the real bar height, so it stays correct
     when padding, logo size or font metrics change. */
  const measure = () => {
    const bar = group.querySelector('header-component');
    if (bar?.offsetHeight) {
      document.documentElement.style.setProperty('--sq-nav-h', `${bar.offsetHeight}px`);
    }
  };

  const sync = () => {
    group.classList.toggle('sq-nav--scrolled', window.scrollY > THRESHOLD);
    ticking = false;
  };

  measure();
  window.addEventListener('resize', measure, { passive: true });
  if (document.fonts?.ready) document.fonts.ready.then(measure);
  if ('ResizeObserver' in window) {
    const bar = group.querySelector('header-component');
    if (bar) new ResizeObserver(measure).observe(bar);
  }

  sync();
  window.addEventListener(
    'scroll',
    () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(sync);
    },
    { passive: true }
  );
})();
